import { memo, useEffect, useState } from "react";

export type IProps = {
    updateTimeCountDown?: (e: any) => void;
    handleTimeEnd?: (e: any) => void;
    countdown?: number;
    stopTimerState?: boolean;
    count?: number;
    timeSetDefault?: string;
    className?: string;
  };

const CCountDown = ({
    updateTimeCountDown,
    handleTimeEnd,
    countdown = 180,
    stopTimerState,
    count,
    timeSetDefault,
    className
}: IProps) => {
    const [timer, setTimer] = useState("05:00");
    const [intervalId, setIntervalId] = useState<any>(null);
    

    const startTimer = () => {
        let countdownTime = countdown || 0;
        const newInterval = setInterval(() => {
            countdownTime -= 1;
            const minutes = Math.floor(countdownTime / 60).toString().padStart(2, "0");
            const seconds = (countdownTime % 60).toString().padStart(2, "0");
            setTimer(`${minutes}:${seconds}`);

            if (countdownTime <= 0) {
                clearInterval(newInterval);
                setTimer("00:00");
            }
            if(typeof updateTimeCountDown == 'function'){
                updateTimeCountDown(countdownTime)
            }
            
        }, 1000);

        setIntervalId(newInterval);
    };

    const stopTimer = (timeSet = '00:00') => {
        if (intervalId) {
            clearInterval(intervalId);
        }
        setTimer(timeSet);
    };

    const startCountDown = () => {
        if (countdown > 0) {
            startTimer();
            return () => {
                stopTimer();
            };
        } else {
            stopTimer();
        }
    }


    useEffect(()=>{
        stopTimer()
    }, [])

    useEffect(() => {
        if(timer == '00:00'){
            handleTimeEnd?.(timer)
        }
    }, [timer]);

    useEffect(() => {
        stopTimer(timeSetDefault || '03:00')
        startCountDown()
    }, [count]);

    useEffect(() => {
        if(stopTimerState){
            stopTimer('03:00')
        }
    }, [stopTimerState]);


   
    return (
        <>
            <span className={`text-[#ff6741] ${className}`}>{timer}</span>
        </>
    );
};

export default memo(CCountDown);
